import { z } from 'zod'
import type { Genre } from './genre'

export const BookStatusEnum = z.enum(['unread', 'reading', 'read', 'wishlist'])
export type BookStatus = z.infer<typeof BookStatusEnum>

export const BookTypeEnum = z.enum(['physical', 'digital'])
export type BookType = z.infer<typeof BookTypeEnum>

/** Owned books form the library; borrowed ones only count as reading */
export const BookOwnershipEnum = z.enum(['owned', 'borrowed'])
export type BookOwnership = z.infer<typeof BookOwnershipEnum>

export const BookSchema = z.object({
  id: z.string().uuid(),
  user_id: z.string().uuid(),
  title: z.string().min(1, 'Title is required'),
  author: z.string().min(1, 'Author is required'),
  isbn: z.string().nullable().optional(),
  cover_url: z.string().url().nullable().optional(),
  rating: z.number().min(1).max(5).nullable().optional(),
  status: BookStatusEnum.default('unread'),
  type: BookTypeEnum.default('physical'),
  ownership: BookOwnershipEnum.default('owned'),
  borrowed_from: z.string().max(100).nullable().optional(),
  start_date: z.string().nullable().optional(),
  end_date: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
})

export const CreateBookSchema = BookSchema.omit({
  id: true,
  user_id: true,
  created_at: true,
  updated_at: true,
})

export const UpdateBookSchema = CreateBookSchema.partial()

export type Book = z.infer<typeof BookSchema> & {
  book_genres?: { genre: Genre }[]
}
export type CreateBook = z.infer<typeof CreateBookSchema> & {
  genreIds?: string[]
}
export type UpdateBook = z.infer<typeof UpdateBookSchema> & {
  genreIds?: string[]
}
